const $ = window.jQuery;

export default class View {
    constructor($el) {
        this.$el = $el;

        if (typeof this.$el === "undefined") {
            console.error(`'Views need a DOM element.`);
            return;
        }

        if (!this.$el.length) {
            console.warn(`'${this.$el.selector}' could not be found in HTML`);
            return;
        }
    }
}
